import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PageTitle from "../../components/PageTitle";
import DetailVideoBox from "../../components/DetailVideoBox";
import DetailTextBox from "../../components/DetailTextBox";
import Service from "../../components/Service";
import data from "../../data/Services.json";
import Chooseus from "../../components/Chooseus";
import chooseData from "./data.json";

class About extends Component {
    async componentDidMount() { }
    render() {
        return (
            <div>
                <Helmet>
                    <title>AsritSolutions | About Us</title>
                </Helmet>
                <div>
                    <PageTitle title="About us" />

                    <section className="seo-section-two">
                        <div className="auto-container">
                            <div className="row clearfix">
                                <DetailTextBox />
                                <br />

                                <DetailVideoBox />
                            </div>
                        </div>
                    </section>

                    <section className="services-section-five">
                        <div
                            className="image-layer"
                            style={{
                                backgroundImage:
                                    "url('https://monomousumi.com/wp-content/uploads/Software-Development-Company.jpg')"
                            }}
                        />
                        <div className="auto-container">
                            <div className="sec-title light centered">
                                <h2>
                                    Discover Services We’r <br /> Provided
                                </h2>
                            </div>
                            <div className="row clearfix">
                                <Service
                                    values={data.web}
                                    text={data.web.desc1}
                                />
                                <Service
                                    values={data.mobile}
                                    text={data.mobile.desc1}
                                />
                                <Service
                                    values={data.cloud}
                                    text={data.cloud.desc1}
                                />
                            </div>
                        </div>
                    </section>

                    <section className="choose-section-two">
                        <div
                            className="map-pattern-layer"
                            style={{
                                backgroundImage:
                                    "url('images/background/pattern-9.png')"
                            }}
                        />
                        <div className="auto-container">
                            <div className="sec-title">
                                <h2>Why Choose Us</h2>
                            </div>

                            <div className="row clearfix">
                                <div className="featured-column col-lg-5 col-md-12 col-sm-12">
                                    <div className="inner-column">
                                        <div className="blocks-outer">
                                            <Chooseus
                                                values={chooseData.choose1}
                                            />
                                            <br />
                                            <Chooseus
                                                values={chooseData.choose2}
                                            />
                                            <br />
                                            <Chooseus
                                                values={chooseData.choose3}
                                            />
                                            <br />
                                        </div>
                                    </div>
                                </div>

                                <div className="images-column col-lg-7 col-md-12 col-sm-12">
                                    <div className="inner-column clearfix">
                                        <div
                                            className="image image-one wow fadeInRight"
                                            data-wow-delay="300ms"
                                            data-wow-duration="1500ms"
                                        >
                                            <img
                                                src="images/resource/seo-5.jpg"
                                                alt=""
                                            />
                                        </div>
                                        <div
                                            className="image image-two wow fadeInRight"
                                            data-wow-delay="0ms"
                                            data-wow-duration="1500ms"
                                        >
                                            <img
                                                src="images/resource/seo-6.jpg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="counter-section style-three">
                        <div className="auto-container">
                            <div className="inner-container">
                                <div className="fact-counter">
                                    <div className="row clearfix">
                                        <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                                            <div
                                                className="inner wow fadeInLeft"
                                                data-wow-delay="0ms"
                                                data-wow-duration="1500ms"
                                            >
                                                <div className="content">
                                                    <div className="count-outer count-box">
                                                        <span
                                                            className="count-text"
                                                            data-speed="2500"
                                                            data-stop="235"
                                                        >
                                                            43
                                                        </span>
                                                    </div>
                                                    <h4 className="counter-title">
                                                        Projects Done
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                                            <div
                                                className="inner wow fadeInLeft"
                                                data-wow-delay="300ms"
                                                data-wow-duration="1500ms"
                                            >
                                                <div className="content">
                                                    <div className="count-outer count-box alternate">
                                                        <span
                                                            className="count-text"
                                                            data-speed="5000"
                                                            data-stop="687"
                                                        >
                                                            37
                                                        </span>
                                                    </div>
                                                    <h4 className="counter-title">
                                                        Satisfied Clients
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                                            <div
                                                className="inner wow fadeInLeft"
                                                data-wow-delay="600ms"
                                                data-wow-duration="1500ms"
                                            >
                                                <div className="content">
                                                    <div className="count-outer count-box">
                                                        <span
                                                            className="count-text"
                                                            data-speed="2000"
                                                            data-stop="582"
                                                        >
                                                            32
                                                        </span>
                                                    </div>
                                                    <h4 className="counter-title">
                                                        Projects Onboard
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                                            <div
                                                className="inner wow fadeInLeft"
                                                data-wow-delay="900ms"
                                                data-wow-duration="1500ms"
                                            >
                                                <div className="content">
                                                    <div className="count-outer count-box">
                                                        <span
                                                            className="count-text"
                                                            data-speed="2500"
                                                            data-stop="129"
                                                        >
                                                            5
                                                        </span>
                                                    </div>
                                                    <h4 className="counter-title">
                                                        Awards Win
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        );
    }
}
export default About;
